import {AxiosError, AxiosResponse} from "axios";
import {injectable} from "inversify";

import "@/extensions/date.extensions";
import {ApiService} from "@/services/apiService";
import {IActivityService} from "@/injection/interfaces";
import {Activity, TinyActivity} from "@/types/entities/activity";
import {SucceededOrNotResponse} from "@/types/responses";

@injectable()
export class ActivityService extends ApiService implements IActivityService {

  public async getActivity(id: string): Promise<Activity> {
    const response = await this._httpClient
      .get<AxiosResponse<Activity>>(`${process.env.VUE_APP_API_BASE_URL}/api/activities/${id}`)
      .catch(function (error: AxiosError): AxiosResponse<Activity> {
        return error.response as AxiosResponse<Activity>;
      });
    return response.data as Activity;
  }

  public async getAllActivities(): Promise<TinyActivity[]> {
    const response = await this._httpClient
      .get<AxiosResponse<Activity[]>>(`${process.env.VUE_APP_API_BASE_URL}/api/activities`)
      .catch(function (error: AxiosError): AxiosResponse<TinyActivity[]> {
        return error.response as AxiosResponse<TinyActivity[]>;
      });
    return response.data as TinyActivity[];
  }

  public async createActivity(data: Activity): Promise<SucceededOrNotResponse> {
    const response = await this._httpClient
      .post<Activity, AxiosResponse<Activity>>(
        `${process.env.VUE_APP_API_BASE_URL}/api/activities`,
        data,
        this.headersWithFormDataContentType())
      .catch(function (error: AxiosError): AxiosResponse<SucceededOrNotResponse> {
        return error.response as AxiosResponse<SucceededOrNotResponse>;
      });
    return response.data as SucceededOrNotResponse;
  }

  public async updateActivity(data: Activity): Promise<SucceededOrNotResponse> {
    const response = await this._httpClient
      .put<Activity, AxiosResponse<Activity>>(
        `${process.env.VUE_APP_API_BASE_URL}/api/activities/${data.id}`,
        data,
        this.headersWithFormDataContentType())
      .catch(function (error: AxiosError): AxiosResponse<SucceededOrNotResponse> {
        return error.response as AxiosResponse<SucceededOrNotResponse>;
      });
    return response.data as SucceededOrNotResponse;

  }

  public async deleteActivity(id: string): Promise<SucceededOrNotResponse> {
    const response = await this._httpClient
      .delete<string, AxiosResponse<SucceededOrNotResponse>>(`${process.env.VUE_APP_API_BASE_URL}/api/activities/${id}`)
      .catch(function (error: AxiosError): AxiosResponse<SucceededOrNotResponse> {
        return error.response as AxiosResponse<SucceededOrNotResponse>;
      });
    return new SucceededOrNotResponse(response.status === 204)
  }
}